import { z } from "zod";
import { type FunctionObjectReturn } from "../utils/functionReturns";

export const ToltCreateClickSchema = z.object({
  param: z.enum(["ref"]),
  value: z.string(),
  country: z.string().optional(),
  device: z.string().optional(),
  page: z.string().optional(),
  referrer: z.string().optional(),
});

export type ToltCreateClickPostBody = z.infer<typeof ToltCreateClickSchema>;

export interface ToltCreateClick {
  partner_id: string;
}

export type ToltCreateClickResponse = FunctionObjectReturn<ToltCreateClick>;
